/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APIRole
 */
export interface APIRole {
    /**
     * 
     * @type {string}
     * @memberof APIRole
     */
    readonly self: string;
    /**
     * 
     * @type {string}
     * @memberof APIRole
     */
    readonly subRoles: string;
    /**
     * 
     * @type {Date}
     * @memberof APIRole
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof APIRole
     */
    readonly lastModifiedAt: Date;
    /**
     * Guest user roles are roles that are reserved for the guest user type. They work like a normal organization user role, but won't be listed by the RoleViewSet.
     * @type {boolean}
     * @memberof APIRole
     */
    isGuestUserRole?: boolean;
    /**
     * 
     * @type {string}
     * @memberof APIRole
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof APIRole
     */
    description?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof APIRole
     */
    permissions?: { [key: string]: any; };
}

/**
 * Check if a given object implements the APIRole interface.
 */
export function instanceOfAPIRole(value: object): value is APIRole {
    if (!('self' in value) || value['self'] === undefined) return false;
    if (!('subRoles' in value) || value['subRoles'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('lastModifiedAt' in value) || value['lastModifiedAt'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function APIRoleFromJSON(json: any): APIRole {
    return APIRoleFromJSONTyped(json, false);
}

export function APIRoleFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIRole {
    if (json == null) {
        return json;
    }
    return {
        
        'self': json['self'],
        'subRoles': json['sub_roles'],
        'createdAt': (new Date(json['created_at'])),
        'lastModifiedAt': (new Date(json['last_modified_at'])),
        'isGuestUserRole': json['is_guest_user_role'] == null ? undefined : json['is_guest_user_role'],
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'permissions': json['permissions'] == null ? undefined : json['permissions'],
    };
}

export function APIRoleToJSON(value?: Omit<APIRole, 'self'|'sub_roles'|'created_at'|'last_modified_at'> | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'is_guest_user_role': value['isGuestUserRole'],
        'name': value['name'],
        'description': value['description'],
        'permissions': value['permissions'],
    };
}

